import type { CreatePaymentResponse } from '../services/api'

type RazorpayCheckout = {
  open: () => void
}

type RazorpayOptions = {
  key: string
  amount: number
  currency: string
  name: string
  order_id?: string
  subscription_id?: string
  prefill?: CreatePaymentResponse['prefill']
  handler: (response: any) => void
  modal: { ondismiss: () => void }
}

declare global {
  interface Window {
    Razorpay?: new (options: RazorpayOptions) => RazorpayCheckout
  }
}

export const openRazorpayCheckout = async (
  payment: CreatePaymentResponse
): Promise<{ success: boolean; isAbandon?: boolean }> => {
  if (!window.Razorpay) {
    await new Promise<void>((resolve, reject) => {
      const existing = document.querySelector<HTMLScriptElement>(
        'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
      )
      if (existing) {
        existing.addEventListener('load', () => resolve(), { once: true })
        existing.addEventListener('error', reject, { once: true })
        return
      }

      const script = document.createElement('script')
      script.src = 'https://checkout.razorpay.com/v1/checkout.js'
      script.onload = () => resolve()
      script.onerror = reject
      document.body.appendChild(script)
    })
  }

  const Razorpay = window.Razorpay
  if (!Razorpay) throw new Error('Razorpay checkout unavailable')

  return new Promise((resolve) => {
    let checkoutSucceeded = false
    const options: RazorpayOptions = {
      key: payment.key_id,
      amount: payment.amount_subunits,
      currency: payment.currency,
      name: 'Lyftr AI',
      prefill: payment.prefill,
      handler: () => {
        checkoutSucceeded = true
        resolve({ success: true })
      },
      modal: {
        ondismiss: () => {
          if (!checkoutSucceeded) {
            resolve({ success: false, isAbandon: true })
          }
        },
      },
    }

    if (payment.checkout_type === 'subscription') {
      options.subscription_id = payment.checkout_id
    } else {
      options.order_id = payment.checkout_id
    }

    new Razorpay(options).open()
  })
}
